import { PersonRoles } from 'models'
import { Moment } from 'moment'
import { PaginationProps, SortDirection } from 'utilities'

export enum PersonsTableSortProps {
  NAME = 'name',
  ROLES = 'roles',
  PROJECTS = 'projects',
  ADDED_AT = 'added at'
}

export type PersonsTableSearchProps = {
  name: string
  role: PersonRoles
  projectName: string
  minAddedAt: Moment
  maxAddedAt: Moment
  tags: string
}

export const initialPersonsTableSearchProps: PersonsTableSearchProps = {
  name: '',
  role: '' as PersonRoles,
  minAddedAt: null,
  maxAddedAt: null,
  projectName: '',
  tags: ''
}

export const initialPersonsTablePaginationProps: PaginationProps<PersonsTableSortProps> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: PersonsTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const personsTableNeedTimeoutProps: Array<keyof PersonsTableSearchProps> = [
  'name', 'projectName', 'tags'
]
